import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, List, ListItem, ListItemText } from "@material-ui/core";
import { TuneIcon, PhoneFA, SearchIcon, StoreAltIcon, } from "../../components/icons";
import CustomTypo from "../../components/CustomTypo";
import { dataUtil, usage_type } from "../../wsclient/crmservices/dataUtil";
import { domainName, portal_config } from "../../../portal.config";
import DrawerCustom from "../../components/DrawerCustom";
import MapInputComponent from "../../components/MapInputComponent";
import { makeStyles } from "@material-ui/styles";
import CustomizedCircularProgress from "../../components/CircularProgress";
import classNames from "classnames";
import { getLogo } from "../../utils/common";

const useStyles = makeStyles((theme) => ({
    drawerRight:{
        padding: theme.spacing(4)
    },
    search: {
         alignItems: 'center',
        position: 'relative',
    },
    search_list: {
        backgroundColor: theme.palette.background.secondary,
        width: '98%',
        position: 'absolute',
        top: theme.spacing(10),
        marginLeft: '1%',
        borderBottomLeftRadius: theme.spacing(3),
        borderBottomRightRadius: theme.spacing(3),
        zIndex:999
    },
    input: {
        marginLeft: theme.spacing(2),
        //flex: 1,
        width: '200%',
    },
    cursor: {
        // borderRadius: theme.spacing(4),
        cursor: "pointer",
        '&:hover': {
            backgroundColor: theme.palette.background.transparent,
            opacity: 0.7,
        },

    },
    tune: {
        position:'absolute',
        right: theme.spacing(1),
        borderRadius: theme.spacing(4),
        cursor: "pointer",
        '&:hover': {
            backgroundColor: theme.palette.background.transparent,
            opacity: 0.7,
        },

    },
    item_container: {
        width: 380,
        height: 120,
        padding: theme.spacing(0, 2, 0, 2),
        cursor: 'pointer',
    },
    item: {
        //backgroundColor: theme.palette.background.secondary,
        //borderRadius: theme.spacing(2)
    },
    item_image: {
        height: 120,
        width: '100%',
        objectFit: 'cover',
        borderTopLeftRadius: theme.spacing(2),
        borderBottomLeftRadius: theme.spacing(2),
    },
    item_right: {
        //width: '60%',
        //marginLeft: theme.spacing(2),
        //marginRight: '5%',
        padding: theme.spacing(4),
        backgroundColor: theme.palette.background.light,
        borderTopRightRadius: theme.spacing(2),
        borderBottomRightRadius: theme.spacing(2)
    },
    tag: {
        backgroundColor: theme.palette.background.tertiary,
        width: 40,
        padding: theme.spacing(1, 2, 1, 2),
        border: '1px solid',
        borderRadius: theme.spacing(4),
        borderColor: theme.palette.border.other,
        textAlign: "center",
    },
    merchant_image: {
        width: 48,
        height: 48,
        // borderRadius: 48,
    },
    merchant_item: {
        padding: theme.spacing(2, 0),
        borderBottom: '1px solid ' + theme.palette.background.card,
    },
    merchant_right: {
        paddingBottom: theme.spacing(2),
    },
    box_phone_number: {
        // background: theme.palette.background.card,
        padding: theme.spacing(1, 0),        
    },
    phone_number: {
        background: theme.palette.background.card,
        padding: theme.spacing(1),
        borderRadius: theme.spacing(1),
        display: 'flex',
        alignItems: 'center',
    },
    custom_input: {
        marginLeft: theme.spacing(10),
    },
    store_box: {
        position: 'absolute',
        right: theme.spacing(10),
        cursor: 'pointer',
        padding: theme.spacing(2),
        borderRadius: theme.spacing(1),
        '&:hover': {
            background: theme.palette.background.card,
        },
    },
    store_box_selected: {
        background: theme.palette.background.card,
    },
    selectBox: {
        // width:theme.spacing(26),
        position:'absolute',
        left: theme.spacing(5),
        zIndex: 1000,
        textAlign:'center',
        justifyContent: 'center',
        alignItems: 'center',
    },
}));

export default function LocationMerchantsView(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    const {
        merchants,
        onSelectMerchant,
        onOpenFilter,
        showSuggestBox,
        merchantsByName,
        open,
        onClose
    } = props;
    console.log("AAAA merchants location list ===", merchants);

    let width = window.innerWidth;
    //console.log('width===',width)
    let number = (width * 40) / 100 / 400;
    let naturalSlideHeight = 40;
    if (width < 1280) {
        number = (width * 50) / 100 / 400;
    } else if (width < 600) {
        number = width / 500;
    }
    return (
        <>
            <DrawerCustom
                open={open}
                onClose={() => onClose()}
                fullScreen
                children={
                    <Grid item className={classes.drawerRight}>
                        <Grid
                            xs={12}
                            item
                            className={classes.search}
                            container
                            alignContent="center"
                        >
                        <Grid item className={classes.selectBox}>
                            <SearchIcon />
                        </Grid>
                            <MapInputComponent
                                isSelectBox={true}
                                onHandleChange={(value) => props.onHandleChange(value, 'merchantpage')}
                                onSelectAddress={props.onSelectAddress}
                                defaultAddress={props.searchValueMerchant}
                                className={classes.custom_input}
                            />
                            <Grid item className={classNames([classes.store_box, classes.store_box_selected])}>
                                <StoreAltIcon />
                            </Grid>
                            {portal_config[domainName].isOfferFilter && (
                                <TuneIcon
                                    className={classes.tune}
                                    onClick={() => onOpenFilter()}
                                    id="btn_location_open_filter"
                                />
                            )}
                            {showSuggestBox && props.searchValueMerchant && merchantsByName.length > 0 ? (
                                <Grid xs={12} item container>
                                    <List className={classes.search_list}>
                                        {merchantsByName.map((item, index) => (
                                            <ListItem
                                                button
                                                key={index}
                                                onClick={() => onSelectMerchant(item)}
                                            >
                                                <ListItemText primary={item.name} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Grid>
                            ) : null}
                        </Grid>
                        {props.showLoading && <CustomizedCircularProgress />}
                        {merchants && (
                            <Grid xs={12} item>
                                <CustomTypo mg_top_xl light variant="caption1">
                                    {t("merchant_near_you")}
                                </CustomTypo>
                                <Grid xs={12} item>
                                    {merchants.map((item, index) => (
                                        <MerchantItem
                                            key={index}
                                            item={item}
                                            classes={classes}
                                            onSelectMerchant={onSelectMerchant}
                                            onDirection={props.onDirection}
                                        />
                                    ))}
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                }
            />
        </>
    );
}

function MerchantItem(props) {
    const { classes, item, onSelectMerchant, onDirection } = props;

    var distance =
        item.location && item.location.distance
            ? item.location.distance.toFixed(2)
            : null;
    // var address = item.location && item.location.address ? item.location.address : "";
    var address = "";
    if (item.location) {
        if (item.location.address_line_1) {
            address = address + item.location.address_line_1;
        }
        if (item.location.address_line_2) {
            address = address + ", " + item.location.address_line_2;
        }
        if (item.location.town_city) {
            address = address + ", " + item.location.town_city;
        }
    }
    var phone_number = null;
    var email = null;
    if (item.contact_info) {
        item.contact_info.forEach((item) => {
            if (item.type === "PHONE") {
                phone_number = item.value;
            } else if (item.type === "EMAIL") {
                email = item.value;
            }
        });
        console.log("phone number:", item.name + "- " + phone_number);
    }
    var covertToKM = 0;
    if (distance) covertToKM = distance * 1.6;
    if (covertToKM) covertToKM = covertToKM.toFixed(2);
    

    return (
        <Grid
            xs={12}
            item
            container
            onClick={() => onSelectMerchant(item)}
            className={classNames([classes.cursor, classes.merchant_item])}
        >
            <Grid xs={3} sm={2} item container justify="center" alignItems="center">
                <MerchantItemImage
                    classes={classes}
                    image={dataUtil.getImageByUsageTypePortal(
                        item.creatives,
                        usage_type.offer_detail_merchant
                    )}
                />
            </Grid>
            <Grid xs={9} sm={10} item className={classes.merchant_right} container>
                <Grid item xs={12}>
                    <Grid xs={12} item>
                        <CustomTypo variant="subtitle2" light>
                            {item.name}
                        </CustomTypo>
                    </Grid>
                    {address ? (
                        <Grid xs={12} item>
                            <CustomTypo variant="input_label" light>
                                {address}
                            </CustomTypo>
                        </Grid>
                    ) : null}
                    {phone_number ? (
                        <Grid item>
                            <Grid item container className={classes.box_phone_number}>
                                <CustomTypo variant="description" light className={classes.phone_number}>
                                    <PhoneFA style={{paddingRight: 4}}/>
                                    {phone_number}
                                </CustomTypo>
                            </Grid>
                        </Grid>
                    ) : null}
                    {email ? (
                        <Grid item>
                            <CustomTypo variant="description" light>
                                {email}
                            </CustomTypo>
                        </Grid>
                    ) : null}
                    {distance ? (
                        <Grid item xs={12}>
                            <CustomTypo variant="description" light>
                                {covertToKM} km ({distance} mi)
                            </CustomTypo>
                        </Grid>
                    ) : null}
                </Grid>
                {/* <Grid
                    item
                    xs={1}
                    container
                    justify="flex-end"
                    onClick={() => onDirection(item.location)}
                    className={classes.google_map}
                >
                    <GoogleMapIcon />
                </Grid> */}
                {/* <Grid item xs={12}>
                    <hr />
                </Grid> */}
            </Grid>
        </Grid>
    );
}

function MerchantItemImage(props) {
    const { classes, image } = props;

    if (image && image.url) {
        return <img src={image.url} className={classes.merchant_image} />;
    } else {
        return <img src={getLogo()} className={classes.merchant_image}></img>;
    }
}

function OfferItem(props) {
    const { classes, item } = props;

    return (
        <div className={classes.item_container}>
            <Grid
                xs={12}
                item
                container
                className={classes.item}
                onClick={() => props.onShowOfferDetail(item)}
            >
                <Grid xs={4} xl={4} item container>
                    <OfferItemImage
                        classes={classes}
                        image={dataUtil.getImageByUsageTypePortal(
                            item.creatives,
                            usage_type.offer_detail
                        )}
                    />
                </Grid>
                <Grid xs={8} xl={8} item container className={classes.item_right}>
                    {item.industry_name && (
                        <Grid xs={12}>
                            <div className={classes.tag}>
                                <CustomTypo variant="body2" color="tertiary">
                                    {item.industry_name}
                                </CustomTypo>
                            </div>
                        </Grid>
                    )}
                    <Grid xs={12} item container>
                        <CustomTypo variant="h6">{item.owned_by.name}</CustomTypo>
                    </Grid>
                    <Grid xs={12} item container>
                        <CustomTypo variant="body2" color="danger">
                            {item.name}
                        </CustomTypo>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
}

function OfferItemImage(props) {
    const { classes, image } = props;

    if (image) {
        return <img src={image.url} className={classes.item_image} />;
    } else {
        return (
            <div></div>
        );
    }
}
